export class Request {

    lastname: string;
    firstname: string;
    email: string;
    object: string;
    content: string;

}
